import React, { useCallback, useEffect, useState } from "react";
import { History, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { eyeVisits, eyeVisitEnroll } from "../lib/api";

const ct = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/Chicago", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) + " CT" : "");
const API = process.env.REACT_APP_BACKEND_URL;

const NameIt = ({ v, userId, onDone }) => {
  const [name, setName] = useState("");
  const save = async () => {
    if (!name.trim()) return;
    try { await eyeVisitEnroll(userId, v.id, name.trim(), "family"); toast.success(`Nexus now knows ${name.trim()}`); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not enroll"); }
  };
  return (
    <span className="flex gap-1 ml-auto">
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name this face" data-testid={`eye-visit-name-${v.id}`}
        className="w-28 bg-[#030712] border border-cyan-300/20 rounded px-2 py-0.5 text-xs" />
      <button onClick={save} data-testid={`eye-visit-enroll-${v.id}`} className="text-emerald-300"><UserPlus className="w-4 h-4" /></button>
    </span>
  );
};

export const EyeVisits = ({ userId }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => eyeVisits(userId).then((d) => setRows(d.visits || [])).catch(() => {}), [userId]);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);
  return (
    <div className="w-full max-w-md nx-glass rounded-2xl p-4 space-y-2" data-testid="eye-visits-panel">
      <p className="text-xs tracking-[0.3em] text-cyan-300/70 font-bold flex items-center gap-2"><History className="w-4 h-4" /> WHO WAS HERE</p>
      {!rows.length && <p className="text-xs text-cyan-200/40">No visits logged yet.</p>}
      {rows.map((v) => (
        <div key={v.id} className="flex items-center gap-2 text-xs" data-testid={`eye-visit-${v.id}`}>
          <span className="text-cyan-200/50 shrink-0">{ct(v.ts)}</span>
          {v.kind === "unknown" ? (
            <>
              {v.snap_id && <a href={`${API}/api/nexus/eye/snap/${v.snap_id}?t=${v.snap_token}`} target="_blank" rel="noreferrer" className="text-rose-300 font-bold">Unknown · photo</a>}
              <NameIt v={v} userId={userId} onDone={load} />
            </>
          ) : (
            <span className={v.kind === "enrolled" ? "text-amber-200" : "text-emerald-300"}>
              <b>{v.name}</b>{v.confidence != null && ` · ${Math.round(v.confidence * 100)}%`}{v.live ? " · live ✓" : ""}{v.kind === "enrolled" ? " · enrolled" : ""}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
